import styled from 'styled-components';

export const CardsContainer = styled.div`
	padding: 0.5%;
	display: grid;
	gap: 16px;
	grid-template-columns: 19% 19% 19% 19% 19%;
`;
